import React from "react";
import PropTypes from "prop-types";
import {
  ActionsListReduced,
  StyledLabel,
  StyledOption,
} from "./styles/candidate-actions-styles";

const interviewLists = {
  "Telephone Interview Requested": [
    { value: "telephone_interview_confirmed", text: "Confirm Interview" },
    { value: "declined_interview", text: "Decline Interview" },
  ],
  "First Interview Requested": [
    { value: "first_interview_confirmed", text: "Confirm Interview" },
    { value: "declined_interview", text: "Decline Interview" },
  ],
  "Second Interview Requested": [
    { value: "second_interview_confirmed", text: "Confirm Interview" },
    { value: "declined_interview", text: "Decline Interview" },
  ],
  "Competencies Required": [
    { value: "competency_test_completed", text: "Completed Test" },
  ],
  "Offered Job": [
    { value: "accepted_job", text: "Accept Job" },
    { value: "rejected_job", text: "Reject Job" },
  ],
};

const RecruiterActionsList = ({ actionsDropdown, optionHandle, jobStatus }) => {
  const options = interviewLists[jobStatus] || [];

  return (
    <ActionsListReduced
      className={actionsDropdown ? "shown dropdown" : "dropdown"}
      id="actions-list"
    >
      <StyledOption type="radio" name="option" id="send_message" />
      <StyledLabel
        htmlFor="send_message"
        onClick={optionHandle}
        value="send_message"
      >
        Send Message
      </StyledLabel>
      {options.map((option) => (
        <React.Fragment key={option.value}>
          <StyledOption type="radio" name="option" id={option.value} />
          <StyledLabel
            id={`${option.value}_label`}
            htmlFor={option.value}
            onClick={optionHandle}
            value={option.value}
          >
            {option.text}
          </StyledLabel>
        </React.Fragment>
      ))}
    </ActionsListReduced>
  );
};

RecruiterActionsList.propTypes = {
  actionsDropdown: PropTypes.bool.isRequired,
  optionHandle: PropTypes.func.isRequired,
  jobStatus: PropTypes.string.isRequired,
};

export default RecruiterActionsList;
